function EmptyState({ title, message }) {
  return (
    <div className="rounded-2xl border border-dashed border-gray-200 bg-white p-6 text-center">
      {title && <p className="font-medium text-gray-700">{title}</p>}
      {message && <p className="mt-1 text-sm text-gray-500">{message}</p>}
    </div>
  );
}

export default EmptyState;
